<template>
    <PageFrame>
        <div>
            <h1>About Open Source Jobs</h1>

            <p>
                Open Source Jobs is a website focused on connecting companies
                and organizations that need open source process and technical
                skills and experience with human beings possessing one and/or
                the other. It operates on the fundamental belief that most of
                today's technology jobs require a minimum amount of both open
                source process and technical experience, whether hiring manages
                are aware of it or not. The modern technical environment has
                evolved and open source knowledge and skills are no longer
                optional. They provide a competitive advantage to both
                companies/organizations and individuals.
            </p>

            <h4>Part of the All Things Open network</h4>

            <p>
                Open Source Jobs is part of the All Things Open network of
                events and platforms. All Things Open hosts thousands of open
                source technologists at live events annually. Events include the
                All Things Open conference, the largest open source/tech/web
                event on the U.S. east coast, the
                <a href="https://opensource101.com/">Open Source 101</a> series,
                and multiple meetups in the
                <a href="https://www.meetup.com/All-Things-Open-RTP-Meetup"
                    >RTP</a
                >
                and
                <a href="https://www.meetup.com/Open-Source-South-Carolina/"
                    >South Carolina.</a
                >
            </p>
        </div>
    </PageFrame>
</template>

<script>
import PageFrame from "@/components/PageFrame.vue";
export default {
    name: "About",

    components: {
        PageFrame
    }
};
</script>
<style lang="scss" scoped>
@import "../scss/vars";

.about {
    background: white;
    padding: 1rem;
    border-radius: $radius;

    @media screen and (min-width: $b1) {
        padding: 2rem;
    }
}
</style>
